<template>
  <div>
    <layout>
      <div slot="content" class="con">
        <swiper v-if="list.length>0" :options="swiperOption" ref="swiperOption" class="swiperWrap">
          <swiper-slide
            v-for="(items,index) in list"
            :key="index"
            class="swiperItem"
            :style="'width:'+imgheight+'rem;height:'+(imgheight+0.586)+'rem'"
          >
            <div class="videobg" :style="'width:'+imgheight+'rem;height:'+imgheight+'rem'">
              <i class="iconfont iconbofang1" @click="Jump()"></i>
            </div>
            <div class="title">
              <p>{{items}}</p>
            </div>
          </swiper-slide>
          <div class="pagWrap" slot="pagination"></div>
        </swiper>
      </div>
    </layout>
    <!-- <TopTabbar :left="false"/>
    <div class="body">
      <div class="videoItem odd">
        <div class="videobg">
          <i class="iconfont iconbofang1" @click="Jump()"></i>
        </div>
        <p>山河集黄金馆视频</p>
      </div>
      <div class="videoItem even">
        <div class="videobg">
          <i class="iconfont iconbofang1" @click="Jump()"></i>
        </div>
        <p>山河集黄金馆视频</p>
      </div>
    </div>
    <Tabbar/>-->
  </div>
</template>
<script>
// import { activeHome } from "../api/http.js";
import layout from "@/components/layout.vue";
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  components: {
    layout
  },
  data() {
    return {
      list: ["山河集黄金馆视频"],
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: false,
        loopedSlide: 5,
        autoplay: false,
        on: {
          progress: function(progress) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              let slideProgress = this.slides[i].progress;
              let modify = 1;
              // if (Math.abs(slideProgress) > 1) {
              //   modify = (Math.abs(slideProgress) - 1) * 0.1 + 1;
              // }
              let translate = slideProgress * 279 + "px";
              let scale = 1 - Math.abs(slideProgress) / 5;
              let zIndex = 100 - Math.abs(Math.round(10 * slideProgress));

              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      }
    };
  },
  computed: {
    imgheight() {
      return (this.$store.state.screenHeight - 175) / 102.4;
    }
  },
  methods: {
    Jump() {
      this.$router.push("/videoDetail");
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.con {
  width: 1024px;
  background: url("../../assets/img/detailbg.jpg");
  background-size: 100%100%;
  height: 100%;
  .swiperWrap {
    padding: 10px;
    height: 100%;
    box-sizing: border-box;
    .swiperItem {
      box-shadow: 0 0 20px #5a4e35;
      .videobg {
        background: url("../../assets/img/video.jpg");
        background-size: 100%100%;
        overflow: hidden;
        position: relative;
        i {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 40px;
          color: #333333;
          background: rgba($color: #fff, $alpha: 0.7);
          height: 70px;
          line-height: 70px;
          text-align: center;
          width: 70px;
          border-radius: 35px;
        }
      }
      .title {
        height: 60px;
        background: #2c2c2c;
        overflow: hidden;
        p {
          height: 44px;
          width: 446px;
          margin: 8px auto;
          line-height: 44px;
          font-size: 16px;
          text-align: center;
          background: url("../../assets/img/bordertop.png");
          background-size: 100%100%;
          color: #d6ad58;
        }
      }
    }
  }
}
</style>
<style>
.pagWrap {
  right: 10px;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  position: absolute;
  text-align: center;
  -webkit-transition: 0.3s opacity;
  -o-transition: 0.3s opacity;
  transition: 0.3s opacity;
  z-index: 10;
  bottom: initial !important;
  left: initial !important;
  width: initial !important;
}
.DetailItem {
  border-radius: 100%;
  background: #fff;
  opacity: 0.7;
  width: 8px;
  height: 8px;
  margin: 10px 0;
  display: block;
  line-height: 26px;
}
.DetailItemactive {
  background: #c9a864;
  opacity: 1;
}
</style>
